import { render } from "./AdminAccomodations.vue?vue&type=template&id=7e181516&scoped=true"
import script from "./AdminAccomodations.vue?vue&type=script&lang=js"
export * from "./AdminAccomodations.vue?vue&type=script&lang=js"

import "./AdminAccomodations.vue?vue&type=style&index=0&id=7e181516&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e181516"]])

export default __exports__